import React from "react";
import "./TechStack.css";
import useScrollReveal from "../hooks/useScrollReveal";

import awsLogo from "../media/logos/aws.svg";
import googlecloudLogo from "../media/logos/googlecloud.svg";
import azureLogo from "../media/logos/azure.svg";
import terraformLogo from "../media/logos/terraform.svg";
import cloudformationLogo from "../media/logos/cloudformation.svg";
import reactLogo from "../media/logos/react.svg";
import nextjsLogo from "../media/logos/nextjs.svg";
import nodejsLogo from "../media/logos/nodejs.svg";
import typescriptLogo from "../media/logos/typescript.svg";
import pythonLogo from "../media/logos/python.svg";
import reactNativeLogo from "../media/logos/react-native.svg";
import flutterLogo from "../media/logos/flutter.svg";
import swiftLogo from "../media/logos/swift.svg";
import kotlinLogo from "../media/logos/kotlin.svg";
import sparkLogo from "../media/logos/apache-spark.svg";
import postgresqlLogo from "../media/logos/postgresql.svg";
import mongodbLogo from "../media/logos/mongodb.svg";
import redisLogo from "../media/logos/redis.svg";
import elasticsearchLogo from "../media/logos/elasticsearch.svg";
import dockerLogo from "../media/logos/docker.svg";
import kubernetesLogo from "../media/logos/kubernetes.svg";
import githubActionsLogo from "../media/logos/github-actions.svg";
import jenkinsLogo from "../media/logos/jenkins.svg";
import prometheusLogo from "../media/logos/prometheus.svg";
import goLogo from "../media/logos/go.svg";
import javaLogo from "../media/logos/java.svg";
import rustLogo from "../media/logos/rust.svg";
import vuejsLogo from "../media/logos/vuejs.svg";

const row1 = [
  { name: "AWS", logo: awsLogo },
  { name: "Google Cloud", logo: googlecloudLogo },
  { name: "Azure", logo: azureLogo },
  { name: "React", logo: reactLogo },
  { name: "Next.js", logo: nextjsLogo },
  { name: "Node.js", logo: nodejsLogo },
  { name: "Python", logo: pythonLogo },
  { name: "TypeScript", logo: typescriptLogo },
  { name: "Go", logo: goLogo },
  { name: "Java", logo: javaLogo },
];

const row2 = [
  { name: "React Native", logo: reactNativeLogo },
  { name: "Flutter", logo: flutterLogo },
  { name: "Swift", logo: swiftLogo },
  { name: "Kotlin", logo: kotlinLogo },
  { name: "Docker", logo: dockerLogo },
  { name: "Kubernetes", logo: kubernetesLogo },
  { name: "Terraform", logo: terraformLogo },
  { name: "Rust", logo: rustLogo },
  { name: "Vue.js", logo: vuejsLogo },
];

const row3 = [
  { name: "Apache Spark", logo: sparkLogo },
  { name: "PostgreSQL", logo: postgresqlLogo },
  { name: "MongoDB", logo: mongodbLogo },
  { name: "Redis", logo: redisLogo },
  { name: "Elasticsearch", logo: elasticsearchLogo },
  { name: "CloudFormation", logo: cloudformationLogo },
  { name: "GitHub Actions", logo: githubActionsLogo },
  { name: "Jenkins", logo: jenkinsLogo },
  { name: "Prometheus", logo: prometheusLogo },
];

function MarqueeRow({ items, direction }) {
  // Duplicate items for seamless loop
  const doubled = [...items, ...items];

  return (
    <div className="marquee-row">
      <div className={`marquee-track marquee-${direction}`}>
        {doubled.map((item, idx) => (
          <div className="marquee-item" key={`${item.name}-${idx}`}>
            <img src={item.logo} alt={item.name} className="marquee-logo" />
            <span className="marquee-name">{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function TechStack() {
  const ref = useScrollReveal();

  return (
    <div ref={ref} className="tech-stack reveal">
      <div className="tech-stack-header">
        <h1>Technologies We Work With</h1>
        <p className="tech-stack-subtitle">
          Battle-tested tools chosen for your product's specific needs
        </p>
      </div>
      <div className="marquee-container">
        <MarqueeRow items={row1} direction="right" />
        <MarqueeRow items={row2} direction="left" />
        <MarqueeRow items={row3} direction="right" />
      </div>
    </div>
  );
}
